import {cloneDeep} from "lodash";
import {getNumber, getString} from 'Core/helpers/data';
import {CustomerGroupsListItemDataObject} from "../dataObjects";

/**
 * Get input data from raw data
 * @param {Object} rawData - Raw data received from IO.
 * @return {CustomerGroupsListItemDataObject}
 */
export const input = rawData => {
	let result = cloneDeep(rawData);

	result = new CustomerGroupsListItemDataObject(
		getString(result, 'id'),
		getString(result, 'name'),
		getString(result, 'projectName'),
		getString(result, 'status'),
		getNumber(result, 'customerCount', null, true),
	);

	return result;
}

// @note There is no output function since a list is read-only.